import { render, staticRenderFns } from "./NationalityList.vue?vue&type=template&id=d79a05b6&scoped=true"
import script from "./NationalityList.vue?vue&type=script&lang=js"
export * from "./NationalityList.vue?vue&type=script&lang=js"
import style0 from "./NationalityList.vue?vue&type=style&index=0&id=d79a05b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d79a05b6",
  null
  
)

export default component.exports